var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSiren(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E64C3C"
    },
    d: "M412.203,407.864H99.797l25.114-326.491c0.521-6.743,6.144-11.95,12.904-11.95h236.37 c6.76,0,12.383,5.207,12.904,11.95L412.203,407.864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M434.26,512H77.743c-6.994,0-12.661-5.667-12.661-12.652v-78.831 c0-6.986,5.667-12.652,12.661-12.652H434.26c6.986,0,12.652,5.667,12.652,12.652v78.831C446.913,506.333,441.246,512,434.26,512"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF372C"
    },
    d: "M412.203,60.746c-2.222,0-4.443-0.85-6.135-2.543c-3.393-3.393-3.393-8.878,0-12.271l26.034-26.034 c3.393-3.393,8.878-3.393,12.271,0s3.393,8.878,0,12.271l-26.034,26.034C416.647,59.895,414.425,60.746,412.203,60.746"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF372C"
    },
    d: "M247.322,43.39c-4.799,0-8.678-3.888-8.678-8.678V8.678c0-4.79,3.879-8.678,8.678-8.678 C252.121,0,256,3.888,256,8.678v26.034C256,39.502,252.121,43.39,247.322,43.39"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF372C"
    },
    d: "M472.949,208.271h-26.034c-4.799,0-8.678-3.888-8.678-8.678s3.879-8.678,8.678-8.678h26.034 c4.799,0,8.678,3.888,8.678,8.678S477.748,208.271,472.949,208.271"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF372C"
    },
    d: "M490.305,347.119h-26.034c-4.799,0-8.678-3.888-8.678-8.678s3.879-8.678,8.678-8.678h26.034 c4.799,0,8.678,3.888,8.678,8.678S495.104,347.119,490.305,347.119"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF372C"
    },
    d: "M91.119,69.424c-2.222,0-4.443-0.85-6.135-2.543L58.949,40.847c-3.393-3.393-3.393-8.878,0-12.271 s8.878-3.393,12.271,0L97.254,54.61c3.393,3.393,3.393,8.878,0,12.271C95.562,68.573,93.34,69.424,91.119,69.424"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF372C"
    },
    d: "M65.085,208.271H39.051c-4.799,0-8.678-3.888-8.678-8.678s3.879-8.678,8.678-8.678h26.034 c4.799,0,8.678,3.888,8.678,8.678S69.884,208.271,65.085,208.271"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF372C"
    },
    d: "M47.729,347.119H21.695c-4.799,0-8.678-3.888-8.678-8.678s3.879-8.678,8.678-8.678h26.034 c4.799,0,8.678,3.888,8.678,8.678S52.528,347.119,47.729,347.119"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3D4763"
    },
    points: "117.153,512 134.508,512 134.508,477.288 117.153,477.288  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3D4763"
    },
    points: "160.542,512 177.898,512 177.898,477.288 160.542,477.288  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3D4763"
    },
    points: "203.932,512 221.288,512 221.288,477.288 203.932,477.288  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3D4763"
    },
    points: "247.322,512 264.678,512 264.678,477.288 247.322,477.288  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3D4763"
    },
    points: "290.712,512 308.068,512 308.068,477.288 290.712,477.288  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3D4763"
    },
    points: "334.102,512 351.458,512 351.458,477.288 334.102,477.288  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3D4763"
    },
    points: "377.492,512 394.847,512 394.847,477.288 377.492,477.288  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF372C"
    },
    d: "M282.034,312.407h-52.068c-4.799,0-8.678-3.888-8.678-8.678s3.879-8.678,8.678-8.678h52.068 c4.799,0,8.678,3.888,8.678,8.678S286.833,312.407,282.034,312.407"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF372C"
    },
    d: "M325.424,144.255v128.035c0,2.942-2.473,5.424-5.415,5.198 C284.203,274.728,256,244.789,256,208.272c0-36.526,28.203-66.456,64.009-69.215C322.951,138.831,325.424,141.304,325.424,144.255 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF372C"
    },
    d: "M186.576,144.255v128.035c0,2.942,2.473,5.424,5.415,5.198 c35.805-2.76,64.009-32.699,64.009-69.215c0-36.526-28.203-66.456-64.009-69.215C189.049,138.831,186.576,141.304,186.576,144.255 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF372C"
    },
    d: "M256,347.119c-4.799,0-8.678-3.888-8.678-8.678V208.271c0-4.79,3.879-8.678,8.678-8.678 c4.799,0,8.678,3.888,8.678,8.678v130.169C264.678,343.231,260.799,347.119,256,347.119"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ECF0F1"
    },
    points: "229.966,407.864 282.034,407.864 282.034,338.441 229.966,338.441  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M299.39,381.831h-86.78c-4.799,0-8.678-3.888-8.678-8.678c0-4.79,3.879-8.678,8.678-8.678h86.78 c4.799,0,8.678,3.888,8.678,8.678C308.068,377.943,304.189,381.831,299.39,381.831"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiren);
export default __webpack_public_path__ + "static/media/siren.15bdaac876dd8022e0d792e8f8330e9c.svg";
export { ForwardRef as ReactComponent };